import React, { useCallback, useEffect } from "react"
import { useIsMobile } from "../../../features/layout/hooks"
import DesktopOnly from "../../../root/punks/mui/visibility/DesktopOnly"
import MobileOnly from "../../../root/punks/mui/visibility/MobileOnly"
import CustomCard from "../../molecules/CustomCard"
import { CustomCol, CustomRow } from "../../spacings"
import FaqContacts from "./FaqContacts"
import FaqContentDialog from "./FaqContentDialog"
import FaqFeedback from "./FaqFeedback"
import FaqPanelNavbar from "./FaqPanelNavbar"
import FaqPanelSections from "./FaqPanelSections"
import { FaqItem, FaqPanelProps, FaqSection } from "./types"
import { useRouter } from "next/router"
import FaqPanelChips from "./FaqPanelChips"
import { TwRichTextField } from "../../../root/punks/core/fields/RichTextField"

const Body = ({
  sections,
  setSelectedCategory,
  selectedCategory,
  selectFaq,
  selectedFaq,
}: any) => {
  return (
    <>
      <DesktopOnly>
        <FaqPanelSections
          sections={sections}
          onSelected={setSelectedCategory}
          selected={selectedCategory}
        />
      </DesktopOnly>
      <MobileOnly>
        <FaqPanelChips
          sections={sections}
          onSelected={setSelectedCategory}
          selected={selectedCategory}
        />
      </MobileOnly>
      <CustomRow spacing className={"lg:mt-12"}>
        <CustomCol xs={12} sm={3}>
          <FaqPanelNavbar
            items={selectedCategory?.items ?? []}
            onClick={selectFaq}
          />
        </CustomCol>
        <CustomCol xs={0} sm={9}>
          <TwRichTextField
            variant="h5"
            value={selectedFaq?.title}
            className="mt-6"
          />
          <div className="my-3">
            <TwRichTextField value={selectedFaq?.content} />
          </div>
          <div>
            {selectedFaq && (
              <FaqFeedback className="mt-16" item={selectedFaq} />
            )}
            <FaqContacts className="my-4" />
          </div>
        </CustomCol>
      </CustomRow>
    </>
  )
}

const FaqPanel = ({ title, sections, query }: FaqPanelProps) => {
  const router = useRouter()
  const [selectedCategory, setSelectedCategory] = React.useState<
    FaqSection | undefined
  >(sections.find((x) => x.slug === query?.category) || sections[0])

  const [selectedFaq, setSelectedFaq] = React.useState<FaqItem | undefined>(
    sections
      .find((x) => x.slug === query?.category)
      ?.items?.find((x) => x.slug === query?.faq) || sections[0].items[0]
  )

  const [faqDialogOpen, setFaqDialogOpen] = React.useState(false)
  const isMobile = useIsMobile()

  useEffect(() => {
    router.replace(
      {
        pathname: router.pathname,
        query: {
          ...router.query,
          category: selectedCategory?.slug,
          faq: selectedFaq?.slug,
        },
      },
      undefined,
      { shallow: true }
    )
  }, [selectedCategory, selectedFaq])

  const selectCategory = useCallback((item: FaqSection) => {
    setSelectedCategory(item)
    setSelectedFaq(item.items?.[0])
  }, [])

  const selectFaq = useCallback((item: FaqItem, isMobile: boolean) => {
    console.log("mob", isMobile)
    setSelectedFaq(item)
    if (isMobile) {
      setFaqDialogOpen(true)
    }
  }, [])
  //   const Head = () => (
  //     <div className="pl-2 mt-4 mb-6 md:my-0 md:pl-0">
  //       <FaqPanelHeader hideSearch onSearch={() => setSearchDialogOpen(true)} />
  //     </div>
  //   )

  return (
    <>
      <MobileOnly className="my-4">
        <TwRichTextField value={title} variant="h6" textCenter />
        {/* <Head /> */}
        <Body
          sections={sections}
          selectFaq={(item: any) => selectFaq(item, isMobile)}
          selectedCategory={selectedCategory}
          selectedFaq={selectedFaq}
          setSelectedCategory={selectCategory}
        />
      </MobileOnly>
      <DesktopOnly className="mt-8 mb-2">
        <TwRichTextField
          value={title}
          variant="h4"
          textCenter
          className={"pt-16 pb-20"}
        />
        <CustomCard
        // head={<Head />}
        >
          <Body
            sections={sections}
            selectFaq={selectFaq}
            selectedCategory={selectedCategory}
            selectedFaq={selectedFaq}
            setSelectedCategory={selectCategory}
          />
        </CustomCard>
      </DesktopOnly>
      <FaqContentDialog
        open={faqDialogOpen}
        item={selectedFaq}
        onClose={() => setFaqDialogOpen(false)}
      />

      {/* <FaqContentDialog
        open={selectedFaq !== undefined}
        item={selectedFaq}
        onClose={() => setSelectedFaq(undefined)}
      />
      <FaqSearchDialog
        items={items}
        open={searchDialogOpen}
        onClose={() => setSearchDialogOpen(false)}
      /> */}
    </>
  )
}

export default FaqPanel
